import { ChannelInfo, ChannelMember } from 'types'
import { sendToApi } from 'api/client'
import { ChannelMembershipOrder } from 'api/clients/ChannelMembershipClient'

export const ChannelClient = {
  updateChannel: (
    id: number,
    {
      color,
      emoji,
      name,
      accessibility,
      workspaceWide,
      description,
    }: {
      color?: string | null
      emoji?: string | null
      name?: string
      workspaceWide?: boolean
      accessibility?: string
      description?: string
    },
  ) =>
    sendToApi<{ channel: ChannelInfo }>(`/channels/${id}`, {
      method: 'PUT',
      body: { channel: { color, emoji, name, accessibility, description, workspace_wide: workspaceWide } },
    }),

  getChannelMembers: async (id: number, order = ChannelMembershipOrder.Asc) => {
    return sendToApi<{ channel_memberships: ChannelMember[] }>(
      `/channels/${id}/channel_memberships?ordered_by_member_name=${order}`,
    )
  },
}
